// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".referenzen_liste .form-control[data-v-19bb5aa0]{color:#323e48}.referenzen_liste .h3[data-v-19bb5aa0]{margin:0 0 20px}@media (min-width:992px){.referenzen_liste .h3[data-v-19bb5aa0]{margin:0 0 0}}.referenzen_liste__filter[data-v-19bb5aa0]{margin:0 0 30px}@media (min-width:992px){.referenzen_liste__flex[data-v-19bb5aa0]{display:flex;align-items:center}}", ""]);
// Exports
module.exports = exports;
